import runSiteMigration from './run-site-migration';
import runSiteBackupMigration from './run-site-backup-migration';

export default {
  runSiteMigration,
  runSiteBackupMigration,
};
